<template>
  <div>
    <Navbar ref="navbarRef" :selectedOption="1" />
    <h4></h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaDiag</th>
          <th scope="col">Severidad</th>
          <th scope="col">Observacion</th>
          <th scope="col">PersonaFechaReg</th>
          <th scope="col">AlergiaNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="alergiapers in datosPaginados" :key="alergiapers.idAlergiaPers">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(alergiapers.idAlergiaPers)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(alergiapers.idAlergiaPers)" title="Editar">edit_square</i></td>
          <td>{{getFormattedDate(alergiapers.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(alergiapers.fechaDiag, 'DD/MM/YYYY')}}</td>
          <td>{{alergiapers.severidad}}</td>
          <td>{{alergiapers.observacion}}</td>
          <td>{{getFormattedDate(alergiapers.personaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{alergiapers.alergiaNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteAlergiaPers(alergiapers.idAlergiaPers)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAlergiaPers" class="form-label">IdAlergiaPers</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAlergiaPers" name="idAlergiaPers" v-model="datoAlergiaPers.idAlergiaPers" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Persona -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoAlergiaPers.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Persona -->
<!-- Botón Lista de Valores  Alergia -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAlergia" class="form-label"> Alergia</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAlergia" name="idAlergia" v-model="datoAlergiaPers.idAlergia">
                      <option v-for="alergia in alergias" :value="alergia.idAlergia" :key="alergia.idAlergia">
                        {{ alergia.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Alergia -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="fechaReg" name="fechaReg" v-model="datoAlergiaPers.fechaReg" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaDiag" class="form-label">FechaDiag</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaDiag" name="fechaDiag" v-model="datoAlergiaPers.fechaDiag" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="severidad" class="form-label">Severidad</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="severidad" name="severidad" v-model="datoAlergiaPers.severidad" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoAlergiaPers.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarAlergiaPers" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAlergiaPers" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';
//import { format } from 'date-fns';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
      alergiaperss : [],
      datoAlergiaPers : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      personas: [],
      alergias: [],
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
/*
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, 'dd/MM/yyyy');
    },
  },
*/

  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.navbarRef.toggleProcesos()
    this.$refs.navbarRef.toggleReportes()
    this.$refs.navbarRef.toggleParametros()
    this.$refs.navbarRef.toggleAyuda()
    this.fetchPersonas()
    this.fetchAlergias()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.alergiaperss.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwalergiaperss/nombre/'+this.nombreBusqueda).then(response=>{
          this.alergiaperss=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.alergiaperss.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwalergiaperss').then(response=>{
      this.alergiaperss=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.alergiaperss.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idPersona'
        ,'idAlergia'
        ,'fechaDiag'
        ,'severidad'
        ,'observacion'
      ];
      const requiredFieldsText = [
        'idPersona'
        ,'idAlergia'
        ,'fechaDiag'
        ,'severidad'
        ,'observacion'
      ];
      return validarForm(this.datoAlergiaPers, requiredFields, requiredFieldsText);
    },
    async guardarAlergiaPers(){
      if(this.validarForm() === 1){
        try {
          await api.post('/alergiaperss', this.datoAlergiaPers)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AlergiaPers creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAlergiaPers(){
      if(this.validarForm() === 1){
        try {
          await api.post('/alergiaperss', this.datoAlergiaPers)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "AlergiaPers creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAlergiaPers={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idAlergiaPers){
      this.modalWindow = true
      if(idAlergiaPers != null){    
           api.get('/vwalergiaperss/'+idAlergiaPers).then(resp=>{
          this.datoAlergiaPers = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idAlergiaPers){
      if(idAlergiaPers != null){
        this.$router.push('/alergiapersmd/'+idAlergiaPers)
      }
    },
    async deleteAlergiaPers (idAlergiaPers) {
      try{
        await api.delete('/alergiaperss/'+idAlergiaPers)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchPersonas() {
      fetch('http://localhost:8080/api/v1/personas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
    fetchAlergias() {
      fetch('http://localhost:8080/api/v1/alergias')
        .then(response => response.json())
        .then(data => {
          this.alergias = data;
        })
        .catch(error => {
          console.error('Error fetching alergias:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
